import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  Timestamp,
} from "firebase/firestore";
import { CustomerNote } from "../leads/customers";

const serializeCreatedAt = (d: Date): string =>
  d instanceof Date && !Number.isNaN(d.getTime()) ? d.toISOString() : new Date().toISOString();

export const customerNoteConverter: FirestoreDataConverter<CustomerNote> = {
  toFirestore: (note: CustomerNote) => {
    const { id: _id, ...data } = note;
    return {
      note: data.note ?? "",
      customerKey: data.customerKey ?? "",
      clientUserId: data.clientUserId ?? "",
      createdByUserId: data.createdByUserId ?? "",
      createdAt: serializeCreatedAt(data.createdAt),
    };
  },

  fromFirestore(
    snapshot: QueryDocumentSnapshot,
    options?: SnapshotOptions,
  ): CustomerNote {
    const data = snapshot.data(options);
    const raw = data?.createdAt;
    let createdAt: Date;
    if (raw instanceof Timestamp) {
      createdAt = raw.toDate();
    } else if (typeof raw === "string") {
      createdAt = new Date(raw);
    } else {
      createdAt = new Date();
    }
    if (Number.isNaN(createdAt.getTime())) {
      createdAt = new Date();
    }

    return {
      id: snapshot.id,
      note: typeof data?.note === "string" ? data.note : "",
      customerKey: typeof data?.customerKey === "string" ? data.customerKey : "",
      clientUserId: typeof data?.clientUserId === "string" ? data.clientUserId : "",
      createdByUserId:
        typeof data?.createdByUserId === "string" ? data.createdByUserId : "",
      createdAt,
    };
  },
};
